
import { TimeStringHelper, TestInstanceVO } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { BasicCustomCursor } from "@goodgamestudios/core";
import { BasicComboboxEvent } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { SFConstants } from "../../constants/SFConstants";
import { Constants } from "../../constants/shared/Constants";
import { Poker2DialogEvent } from "../../event/Poker2DialogEvent";
import { Poker2LobbyDetailEvent } from "../../event/Poker2LobbyDetailEvent";
import { Poker2TournamentDataEvent } from "../../event/Poker2TournamentDataEvent";
import { LobbyTablesVO } from "../../gamevo/LobbyTablesVO";
import { TournamentVO } from "../../gamevo/TournamentVO";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2MouseWheelUpDown } from "../components/Poker2MouseWheelUpDown";
import { PokerTextHelper } from "../helper/PokerTextHelper";
import { Poker2Screen } from "./Poker2Screen";

import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;

export class Poker2TournamentScreen extends Poker2Screen {
    public static NAME: string = "Poker2TournamentScreen";

    private MAX_LINES: number = 15;
    private sortComboBox: Poker2DynamicCombobox;
    private startTime: number = 0;
    private currentSort: number = 0;
    private mouseWheelUpDown: Poker2MouseWheelUpDown;
    private static TOURNAMENT_TABLE_COLUMNS_AMOUNT: number = 5;
    private static TABLE_HEAD_TOOLTIPS: any[];
    private SELECT_ALL_POS: number = 3;
    private SHOW_ALL_TABLETYPES: number = -1;
    private DEACTIVATE_JOINBUTTON: number = -1;
    private _tournaments: LobbyTablesVO[];
    private _selectedLineVO: SelectedLineVO;

    constructor(disp: DisplayObject) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    protected init(): void {
        super.init();
        this.mouseWheelUpDown = new Poker2MouseWheelUpDown();
        this.mouseWheelUpDown.init(this.tournamentScreen.btn_up, this.tournamentScreen.btn_down, this.tournamentScreen);

        // Map tooltips to the table head buttons.
        // Caution, order of the table header buttons in the fla is: 0,1,2,3,4
        // 0 = tables
        // 1 = fee
        // 2 = state
        // 3 = players
        // 4 = pot
        Poker2TournamentScreen.TABLE_HEAD_TOOLTIPS = [Poker2Model.languageData.getTextById("lobby_tab_tooltip_tables"),
        Poker2Model.languageData.getTextById("lobby_tab_tooltip_fee"),
        Poker2Model.languageData.getTextById("lobby_tab_tooltip_state"),
        Poker2Model.languageData.getTextById("lobby_tab_tooltip_players"),
        Poker2Model.languageData.getTextById("lobby_tab_tooltip_pot")];
        this.initToolTips();

        this.tournamentScreen.bg.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
        this.tournamentScreen.bg_title.doCache();
    }

    private initToolTips(): void {
        // tooltip refresh button
        this.tournamentScreen.btn_refresh.toolTipText = Poker2Model.languageData.getTextById("lobby_btn_tooltip_refresh");

        this.initToolTipsTableHead();
    }

    private initToolTipsTableHead(): void {
        var i: number = 0;
        var len: number = Poker2TournamentScreen.TOURNAMENT_TABLE_COLUMNS_AMOUNT;
        var tempTableHeadButton: MovieClip;
        for (i = 0; i < len; ++i) {
            tempTableHeadButton = this.tournamentScreen["sort_" + i];
            tempTableHeadButton.toolTipText = Poker2TournamentScreen.TABLE_HEAD_TOOLTIPS[i];
        }
    }

    public show(): void {
        super.show();
        this.initComponents();
        if (this.sortComboBox) {
            this.sortComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onSortComboboxChange));
        }
        this.controller.addEventListener("changeTournamentData", this.bindFunction(this.onTournamentData));
        this.controller.addEventListener("registerTournament", this.bindFunction(this.onTournamentRegister));
        this.controller.addEventListener("unregisterTournament", this.bindFunction(this.onTournamentUnregister));
        this.controller.addEventListener("blurSelectedTableLine", this.bindFunction(this.blurSelectedLine));

        this.disableJoinButton();
        this.tournamentScreen.btn_tables.deselected();
        this.tournamentScreen.btn_tournament.selected();
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2TournamentScreen", 1]));
        this.mouseWheelUpDown.activateMouseWheel();

        TableHeadButtonHelper.setHeadButtonsSizes([0.93, 1, 1.58, 0.96, 0.90], this.tournamentScreen);
    }

    public hide(): void {
        if (this.sortComboBox) {
            this.sortComboBox.disp.removeEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onSortComboboxChange));
        }
        this.mouseWheelUpDown.deactivateMouseWheel();
        this.controller.removeEventListener("changeTournamentData", this.bindFunction(this.onTournamentData));
        this.controller.removeEventListener("registerTournament", this.bindFunction(this.onTournamentRegister));
        this.controller.removeEventListener("unregisterTournament", this.bindFunction(this.onTournamentUnregister));
        this.controller.removeEventListener("blurSelectedTableLine", this.bindFunction(this.blurSelectedLine));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2TournamentScreen", 0]));
        this._selectedLineVO = null;
        super.hide();
    }

    private onSortComboboxChange(event: BasicComboboxEvent): void {
        if (this.sortComboBox.selectedId != this.SELECT_ALL_POS) {
            Poker2Model.userData.tournamentConfigVO.tabletype = this.sortComboBox.selectedId;
        }
        else {
            Poker2Model.userData.tournamentConfigVO.tabletype = this.SHOW_ALL_TABLETYPES;
        }
        this.updateSettings(["tabletype"]);
    }

    public destroy(): void {
        super.destroy();
        this.controller.removeEventListener("blurSelectedTableLine", this.bindFunction(this.blurSelectedLine));
        for (var i: number = 0; i < this.MAX_LINES; i++) {
            var tItem: Library.PokerInterface.TournamentTableLine = this.tournamentScreen["line" + i] as Library.PokerInterface.TournamentTableLine;
            tItem.mc_registered.removeAllEventListeners(MouseEvent.ROLL_OVER);
            tItem.mc_registered.removeAllEventListeners(MouseEvent.ROLL_OUT);
            tItem.removeAllEventListeners(MouseEvent.ROLL_OVER);
            tItem.removeAllEventListeners(MouseEvent.ROLL_OUT);
        }
        this.mouseWheelUpDown.destroy();
    }

    private onTournamentRegister(event: Poker2TournamentDataEvent): void {
        this.refreshTournamentList();
    }

    private onTournamentUnregister(event: Poker2TournamentDataEvent): void {
        this.refreshTournamentList();
    }

    private onTournamentData(event: Poker2TournamentDataEvent): void {
        this.fillTables(Poker2Model.tournamentData.tournamentList);
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.target) {
            case this.tournamentScreen.btn_info:
                this.layoutManager.showDialog("Poker2HelpTournamentDialog");
                break;
            case this.tournamentScreen.btn_tables:

                BasicModel.smartfoxClient.sendMessage("tli", [JSON.stringify({})]);
                this.layoutManager.state = 11;
                break;
            case this.tournamentScreen.btn_tournament:
                this.layoutManager.state = 14;
                break;
            case this.tournamentScreen.btn_sitngo:

                BasicModel.smartfoxClient.sendMessage("sli", [JSON.stringify({})]);
                this.layoutManager.state = 17;
                break;
            case this.tournamentScreen.sort_0:
            case this.tournamentScreen.sort_1:
            case this.tournamentScreen.sort_2:
            case this.tournamentScreen.sort_3:
            case this.tournamentScreen.sort_4:
                this.currentSort = int(event.target.properties);
                this.refreshTournamentList(event.target.properties);

                // hgs HS859: erzwinge den anzeigewechsel, solange die maus über dem objekt bleibt
                (event.target as Library.PokerInterface.TabelButton).toggleDropDown();
                event.target.dispatchEvent(new MouseEvent(MouseEvent.ROLL_OUT));
                event.target.dispatchEvent(new MouseEvent(MouseEvent.ROLL_OVER));
                break;
            case this.tournamentScreen.btn_play_table:
                if (this.tournamentScreen.btn_play_table.enabled && this._selectedLineVO) {
                    this.tournamentAction(this._selectedLineVO);
                }
                break;
            case this.tournamentScreen.btn_refresh:
                var paramObject: any = {};
                BasicModel.smartfoxClient.sendMessage("jli", [JSON.stringify(paramObject)]);
                break;
            case this.tournamentScreen.btn_up:
                this.updateSettings(["up"]);
                break;
            case this.tournamentScreen.btn_down:
                if (this.tournamentScreen.btn_down.enabled)
                    this.updateSettings(["down"]);
                break;
            default:
                if (instanceOfClass(event.target, "TableLineBG")) {
                    var item: Library.PokerInterface.TournamentTableLine = event.target.parent as Library.PokerInterface.TournamentTableLine;
                    this.activateTableLine(item);
                    this.updateJoinButton(item.selectedLineVO.status);
                }
        }
    }

    private updateSettings(properties: any[]): void {
        var paramObject: any;
        paramObject = new Object();

        for (var i: number = 0; i < properties.length; i++) {
            paramObject[properties[i]] = Poker2Model.userData.tournamentConfigVO[properties[i]];
        }
        BasicModel.smartfoxClient.sendMessage("jli", [JSON.stringify(paramObject)]);
    }

    private tournamentAction(vo: SelectedLineVO): void {
        var status: number = vo.status;
        var tournamentId: number = vo.id;

        switch (status) {
            case 0:
                this.register(tournamentId);
                this.updateJoinButton(1);
                this._selectedLineVO.status = int(1);
                break;
            case 1:
                this.unregister(tournamentId);
                this.updateJoinButton(0);
                this._selectedLineVO.status = int(0);
                break;
            case 2:
                this.layoutManager.state = 15;
                this.watchTournament(tournamentId);
                break;
            case 3:
            case 5:
                this.playTournament(tournamentId);
                break;
            case 4:
                this.layoutManager.state = 15;
                this.watchTournament(tournamentId);
                break;
        }
    }

    private register(tournamentId: number): void {
        var paramObject: any = { id: tournamentId };
        BasicModel.smartfoxClient.sendMessage("jre", [JSON.stringify(paramObject)]);
    }

    private unregister(tournamentId: number): void {
        var paramObject: any = { id: tournamentId };
        BasicModel.smartfoxClient.sendMessage("jur", [JSON.stringify(paramObject)]);
    }

    private watchTournament(tournamentId: number): void {
        //Poker2Model.tournamentData.spectatorTournamentId = tournamentId;
        var paramObject: any = { id: tournamentId, sort: 0 };
        BasicModel.smartfoxClient.sendMessage("jts", [JSON.stringify(paramObject)]);
    }

    private playTournament(tournamentId: number): void {
        var paramObject: any = { id: tournamentId };
        BasicModel.smartfoxClient.sendMessage("jjn", [JSON.stringify(paramObject)]);
    }

    private refreshTournamentList(sortIndex: number = -1): void {
        if (this.layoutManager.currentState == 14) {
            var paramObject: any = {};
            if (sortIndex != -1) {
                paramObject.sort = sortIndex;
            }

            BasicModel.smartfoxClient.sendMessage("jli", [JSON.stringify(paramObject)]);
        }
    }

    private showTournamentInfo(tournamentVO: TournamentVO): void {
        // store selected TournamentVO
        Poker2Model.tournamentData.selectedTournamentVO = tournamentVO;

        var paramObject: any = { id: tournamentVO.id };
        BasicModel.smartfoxClient.sendMessage("jio", [JSON.stringify(paramObject)]);
    }

    private hideTournamentInfo(): void {
        this.controller.dispatchEvent(new Poker2LobbyDetailEvent("hideDetail"));
    }

    protected onMouseOver(event: MouseEvent): void {
        switch (event.target) {
            default:
                if (instanceOfClass(event.target, "TournamentTableLine")) {
                    var item: Library.PokerInterface.TournamentTableLine = event.target as Library.PokerInterface.TournamentTableLine;

                    this.highlightLine(item.selectedLineVO);
                    this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
                }
        }
        super.onMouseOver(event);
    }

    protected onMouseOut(event: MouseEvent): void {
        switch (event.target) {
            default:
                if (instanceOfClass(event.target, "TournamentTableLine")) {
                    var item: Library.PokerInterface.TournamentTableLine = event.target as Library.PokerInterface.TournamentTableLine;

                    if (!this._selectedLineVO || (this._selectedLineVO && item.selectedLineVO.id != this._selectedLineVO.id)) {
                        this.blurLine(item.selectedLineVO);
                    }

                    this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
                }
        }
        super.onMouseOut(event);
    }

    private initComponents(): void {

        if (this.sortComboBox == null) {
            this.sortComboBox = new Poker2DynamicCombobox(this.tournamentScreen.combo_sort, "", 4);
            this.sortComboBox.addItem({ label: Poker2Model.languageData.getTextById("lobby_combo_tournamentTyp_0") });
            this.sortComboBox.addItem({ label: Poker2Model.languageData.getTextById("lobby_combo_tournamentTyp_1") });
            this.sortComboBox.addItem({ label: Poker2Model.languageData.getTextById("lobby_combo_tournamentTyp_2") });
            this.sortComboBox.addItem({ label: Poker2Model.languageData.getTextById("create_table_combo_player_1") });
        }
        this.initComboBoxes();
        this.initTextFields();
        this.setHelperProperties();
    }

    private initComboBoxes(): void {
        if (Poker2Model.userData.tournamentConfigVO) {
            var selectedTableTyp: string;
            if (Poker2Model.userData.tournamentConfigVO.tabletype != this.SHOW_ALL_TABLETYPES) {
                selectedTableTyp = Poker2Model.languageData.getTextById("lobby_combo_tournamentTyp_" + Poker2Model.userData.tournamentConfigVO.tabletype);
            }
            else {
                selectedTableTyp = Poker2Model.languageData.getTextById("create_table_combo_player_1");
            }
            this.sortComboBox.defaultString = selectedTableTyp;
            this.sortComboBox.hideItems();
        }
        else {
            this.sortComboBox.selectItemIndex(0);
        }
    }

    private initTextFields(): void {
        this.tournamentScreen.txt_tournament_sort.text = Poker2Model.languageData.getTextById("lobby_tournamentTyp");

        this.updateJoinButton(0);

        this.tournamentScreen.btn_info.toolTipText = Poker2Model.languageData.getTextById("menu_btn_help");
        this.tournamentScreen.txt_tables.text = Poker2Model.languageData.getTextById("lobby_tour_name");
        this.tournamentScreen.txt_fee.text = Poker2Model.languageData.getTextById("lobby_tour_fee");
        this.tournamentScreen.txt_status.text = Poker2Model.languageData.getTextById("lobby_tour_status");
        this.tournamentScreen.txt_players.text = Poker2Model.languageData.getTextById("lobby_players");
        this.tournamentScreen.txt_pot.text = Poker2Model.languageData.getTextById("lobby_pot");
        this.tournamentScreen.txt_title.text = Poker2Model.languageData.getTextById("lobby_tournament_title");
        this.tournamentScreen.btn_tables.toolTipText = Poker2Model.languageData.getTextById("menu_btn_lobby");
        this.tournamentScreen.btn_sitngo.toolTipText = Poker2Model.languageData.getTextById("lobby_sitngo_title");
        this.tournamentScreen.txt_tables.mouseEnabled = false;
        this.tournamentScreen.txt_fee.mouseEnabled = false;
        this.tournamentScreen.txt_status.mouseEnabled = false;
        this.tournamentScreen.txt_players.mouseEnabled = false;
        this.tournamentScreen.txt_pot.mouseEnabled = false;

        // TODO: final text
        this.tournamentScreen.btn_tournament_info.visible = false;
    }

    private fillTables(tournaments: LobbyTablesVO[]): void {
        this._tournaments = tournaments;

        if (tournaments.length < this.MAX_LINES)
            this.tournamentScreen.btn_down.enableButton = false;
        else
            this.tournamentScreen.btn_down.enableButton = true;

        for (var i: number = 0; i < this.MAX_LINES; i++) {
            var tItem: Library.PokerInterface.TournamentTableLine = this.tournamentScreen["line" + i] as Library.PokerInterface.TournamentTableLine;

            if (tournaments.length - 1 < i) {
                tItem.visible = false;
                continue;
            }

            tItem.properties = tournaments[i].tournamentVO.id;
            tItem.visible = true;

            tItem.selectedLineVO = new SelectedLineVO(tournaments[i].tournamentVO.id, tournaments[i].tournamentVO.status, tItem);

            // check visibility
            if (this._selectedLineVO && tItem.selectedLineVO.id == this._selectedLineVO.id) {
                this.highlightLine(tItem.selectedLineVO);
            }
            else {
                this.blurLine(tItem.selectedLineVO);
            }

            tItem.tournamentVO = tournaments[i].tournamentVO;
            TextFieldHelper.changeTextFromatSizeByTextWidth(9, tItem.txt_name, tournaments[i].tournamentVO.name);
            tItem.txt_chips.text = PokerTextHelper.getShortGroupNumberString(tournaments[i].tournamentVO.chipsFee);
            tItem.txt_gold.text = tournaments[i].tournamentVO.goldFee.toString();
            var startTime: number = (tournaments[i].tournamentVO.startTime);
            var time: string = TimeStringHelper.getTimeToString(startTime, TimeStringHelper.TWO_TIME_FORMAT, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));

            if (startTime <= 0)
                tItem.txt_status.text = Poker2Model.languageData.getTextById("lobby_tour_active");
            else
                tItem.txt_status.text = time;

            tItem.txt_players.text = tournaments[i].tournamentVO.currentPlayers.toString();
            tItem.txt_pot.text = tournaments[i].tournamentVO.pot.toString();

            if (tournaments[i].tournamentVO.status == 1 || tournaments[i].tournamentVO.status == 3) {
                // registered
                tItem.mc_registered.gotoAndStop(1);
                tItem.mc_registered.toolTipText = Poker2Model.languageData.getTextById("lobby_tournament_status_tooltip_0");
            }
            else {
                // not registered
                tItem.mc_registered.gotoAndStop(2);
                tItem.mc_registered.toolTipText = Poker2Model.languageData.getTextById("lobby_tournament_status_tooltip_1");
            }

            tItem.mouseChildren = true;
            tItem.mc_background.mouseEnabled = true;
            tItem.mc_background.mouseChildren = false;
            tItem.mc_chips.mouseEnabled = false;
            tItem.mc_gold.mouseEnabled = false;
            tItem.txt_name.mouseEnabled = false;
            tItem.txt_chips.mouseEnabled = false;
            tItem.txt_gold.mouseEnabled = false;
            tItem.txt_status.mouseEnabled = false;
            tItem.txt_players.mouseEnabled = false;
            tItem.txt_pot.mouseEnabled = false;
            tItem.removeAllEventListeners(MouseEvent.ROLL_OVER);
            tItem.removeAllEventListeners(MouseEvent.ROLL_OUT);
            tItem.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onMouseOver));
            tItem.addEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onMouseOut));
            tItem.mc_registered.removeAllEventListeners(MouseEvent.ROLL_OVER);
            tItem.mc_registered.removeAllEventListeners(MouseEvent.ROLL_OUT);
            tItem.mc_registered.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onMouseOver));
            tItem.mc_registered.addEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onMouseOut));
        }
    }

    private disableJoinButton(): void {
        this.tournamentScreen.btn_play_table.enableButton = false;
        this.tournamentScreen.btn_play_table.toolTipText = Poker2Model.languageData.getTextById("lobby_sitngo_registerBtn_inactive_tt");
    }

    private updateJoinButton(status: number): void {
        this.tournamentScreen.btn_play_table.toolTipText = null;

        switch (status) {
            case 0:
                this.tournamentScreen.btn_play_table.enableButton = true;
                this.tournamentScreen.btn_play_table.label = Poker2Model.languageData.getTextById("lobby_tour_register");
                break;
            case 1:
                this.tournamentScreen.btn_play_table.enableButton = true;
                this.tournamentScreen.btn_play_table.label = Poker2Model.languageData.getTextById("lobby_tour_unregister");
                break;
            case 2:
                this.tournamentScreen.btn_play_table.enableButton = true;
                this.tournamentScreen.btn_play_table.label = Poker2Model.languageData.getTextById("lobby_tables");
                break;
            case 3:
            case 5:
                this.tournamentScreen.btn_play_table.enableButton = true;
                this.tournamentScreen.btn_play_table.label = Poker2Model.languageData.getTextById("lobby_tour_play");
                break;
            case 4:
                this.tournamentScreen.btn_play_table.enableButton = true;
                this.tournamentScreen.btn_play_table.label = Poker2Model.languageData.getTextById("lobby_tables");
                break;
            default: this.disableJoinButton();
                break;
        }
    }

    private activateTableLine(line: Library.PokerInterface.TournamentTableLine): void {
        if (this._selectedLineVO && this._selectedLineVO.id == line.selectedLineVO.id) {
            this.blurLine(this._selectedLineVO);
            this.hideTournamentInfo();
            this._selectedLineVO = null;
            return;
        }

        if (this._selectedLineVO == null) {
            this._selectedLineVO = line.selectedLineVO;
            this.highlightLine(this._selectedLineVO);
            this.showTournamentInfo(line.tournamentVO);
            return;
        }

        if (this._selectedLineVO && this._selectedLineVO.id != line.selectedLineVO.id) {
            // blur previous selected line
            this.blurLine(this._selectedLineVO);

            this._selectedLineVO = line.selectedLineVO;
            this.highlightLine(this._selectedLineVO);
            this.showTournamentInfo(line.tournamentVO);
        }
    }

    private highlightLine(vo: SelectedLineVO): void {
        vo.line.mc_background.gotoAndStop(2);
    }

    private blurLine(vo: SelectedLineVO): void {
        vo.line.mc_background.gotoAndStop(1);
    }

    private blurSelectedLine(event: Event): void {
        // blur selected line
        if (this._selectedLineVO) {
            this.blurLine(this._selectedLineVO);
        }
    }

    private setHelperProperties(): void {
        for (var i: number = 0; i < 5; i++) {
            this.tournamentScreen["sort_" + i].properties = i;
        }
    }

    public get tournamentScreen(): Library.PokerInterface.PokerTournamentLobby {
        return this.disp as Library.PokerInterface.PokerTournamentLobby;
    }
}
import {Poker2DynamicCombobox} from "../components/Poker2DynamicCombobox";
import { Poker2HelpTournamentDialog } from "../dialogs/Poker2HelpTournamentDialog";
import { Poker2LayoutManager } from "../Poker2LayoutManager";

class SelectedLineVO {
    public id: number = 0;
    public status: number = 0;
    public line: Library.PokerInterface.TournamentTableLine;
    public infoVisible: boolean = false;

    constructor(id: number, status: number, line: Library.PokerInterface.TournamentTableLine) {
        this.id = id;
        this.status = status;
        this.line = line;
    }

    public toString(): string {
        return "id: " + this.id + ", status: " + this.status + ", line: " + this.line;
    }
}
import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import {TableHeadButtonHelper} from "../helper/TableHeadButtonHelper";
